import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { onclick: "zeigeHilfe('1319')" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-life-ring" })
], -1)
const _hoisted_4 = { class: "d-flex flex-row" }
const _hoisted_5 = { class: "flex-fill" }
const _hoisted_6 = { class: "nav nav-tabs nav-tabs-highlight" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "tabbable" }
const _hoisted_9 = { class: "tab-content" }
const _hoisted_10 = {
  key: 0,
  class: "card"
}
const _hoisted_11 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_12 = {
  key: 1,
  class: "alert alert-info col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ObjectRow = _resolveComponent("ObjectRow")!
  const _component_ObjectDetailBar = _resolveComponent("ObjectDetailBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.headline) + " ", 1),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusConfig, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "nav-item"
            }, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", item.code == _ctx.activeTab ? 'active' : '']),
                "data-toggle": "tab",
                "aria-expanded": "true",
                onClick: ($event: any) => (_ctx.activeTab = item.code)
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["mr-1", _ctx.statusConfig[item.code].icon])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(item.name), 1)
              ], 10, _hoisted_7)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProjects, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["tab-pane p-0", index == _ctx.activeTab ? 'active' : ''])
              }, [
                (item.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("ul", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (project, i) => {
                          return (_openBlock(), _createBlock(_component_ObjectRow, {
                            key: i,
                            data: project,
                            onClicked: _ctx.showProjectDetail
                          }, null, 8, ["data", "onClicked"]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, "Für diese Ansicht sind keine Daten vorhanden"))
              ], 2))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_ObjectDetailBar, {
        show: _ctx.showProjectDetailBar,
        details: _ctx.projectDetail,
        onClose: _ctx.closeProjectDetail
      }, null, 8, ["show", "details", "onClose"])
    ])
  ]))
}